module.exports = __webpack_public_path__ + "img/copper-iud.41a0b373.png";